/**
 * Vehicle equipment / option — référentiel partagé géré par l'admin
 * (`net.nawam.rental.model.entity.Option`). Rattaché aux véhicules en
 * `@ManyToMany` (POST/DELETE `/api/vehicles/{id}/me/options`).
 */

export type OptionCategory =
  | 'CONFORT'
  | 'SECURITE'
  | 'TECHNOLOGIE'
  | 'EXTERIEUR'
  | 'INTERIEUR'
  | 'AUTRE';

export interface VehicleOption {
  id: number;
  nameFr: string;
  nameEn?: string | null;
  /** URL-safe stable id (ex. `climatisation`, `camera-recul`). Unique. */
  slug: string;
  icon?: string | null;
  category?: OptionCategory | null;
}

export const OPTION_CATEGORY_LABEL: Record<OptionCategory, string> = {
  CONFORT: 'label.optionCategory.CONFORT',
  SECURITE: 'label.optionCategory.SECURITE',
  TECHNOLOGIE: 'label.optionCategory.TECHNOLOGIE',
  EXTERIEUR: 'label.optionCategory.EXTERIEUR',
  INTERIEUR: 'label.optionCategory.INTERIEUR',
  AUTRE: 'label.optionCategory.AUTRE',
};

/** Ordre d'affichage stable pour les sections groupées. */
export const OPTION_CATEGORY_ORDER: OptionCategory[] = [
  'CONFORT',
  'SECURITE',
  'TECHNOLOGIE',
  'EXTERIEUR',
  'INTERIEUR',
  'AUTRE',
];
